var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIndoorTechnical(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 42 42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m21.971,23.896l6.778-6.778c2.604,1.083,5.715.568,7.833-1.55,2.061-2.061,2.6-5.061,1.631-7.621l-3.951,3.951h-2.468s-1.832-1.832-1.832-1.832l.14-2.328,3.951-3.951c-2.559-.97-5.56-.43-7.621,1.631-2.118,2.118-2.633,5.229-1.55,7.833l-11.63,11.63c-2.604-1.083-5.715-.568-7.833,1.55-2.061,2.061-2.6,5.061-1.631,7.621l4.345-4.345h2.468s1.832,1.832,1.832,1.832l-.14,2.328-4.345,4.345c2.559.97,5.56.43,7.621-1.631,2.118-2.118,2.633-5.229,1.55-7.833l4.852-4.852"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIndoorTechnical);
export default __webpack_public_path__ + "static/media/indoor-technical.97d5ca4624e1f71d1aea89d180a3b23e.svg";
export { ForwardRef as ReactComponent };